import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, useResponsiveValue, Link, Text } from "braid-design-system";
import { forwardRef } from "react";
import { useLink } from "../../../ApacCandidateFooter/components/Accordion/Accordion.mjs";
import { TabBadge } from "../TabBadge/TabBadge.mjs";
import { translations } from "../../../../ApacCandidateHeader/components/Tabs/.vocab/index.mjs";
import { linkText, activeLink, tabBottomStrip, activeTabBottomStrip, tab, activeTab, responsiveWidth } from "./Tabs.css.mjs";
const Tab = ({
  href,
  text,
  isActive = false,
  linkContext,
  isNew = false
}) => {
  const responsiveValue = useResponsiveValue();
  const responsiveTextSize = responsiveValue({ mobile: "standard", tablet: "small" }) || "small";
  const { injectLinkContextToData } = useLink();
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsxs(
    Link,
    {
      href,
      className: [tab, { [activeTab]: isActive }],
      data: injectLinkContextToData(linkContext, {
        automation: linkContext.source,
        "automation-role": "nav-tabs"
      }),
      children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            component: "span",
            display: "flex",
            alignItems: "center",
            height: "full",
            position: "relative",
            marginRight: isNew ? "xsmall" : "none",
            paddingLeft: ["small", "none"],
            paddingY: ["medium", "none"],
            children: [
              /* @__PURE__ */ jsx(
                Text,
                {
                  size: responsiveTextSize,
                  weight: isActive ? "medium" : void 0,
                  children: /* @__PURE__ */ jsx(
                    Box,
                    {
                      "data-title": text,
                      component: "span",
                      className: [linkText, { [activeLink]: isActive }],
                      children: text
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx(
                Box,
                {
                  component: "span",
                  display: ["none", "inline"],
                  className: [
                    tabBottomStrip,
                    {
                      [activeTabBottomStrip]: isActive
                    }
                  ]
                }
              )
            ]
          }
        ),
        isNew ? /* @__PURE__ */ jsx(TabBadge, { tone: "positive", bleedY: true, children: t("New") }) : null
      ]
    }
  );
};
const Tabs = forwardRef(({ tabList }, ref) => /* @__PURE__ */ jsx(
  Box,
  {
    className: responsiveWidth,
    display: "flex",
    flexDirection: ["column", "row"],
    alignItems: ["flexStart", "center"],
    ref,
    children: tabList.map(
      ({ href, text, tabId, linkContext, isNew, isActive }, index) => /* @__PURE__ */ jsx(
        Box,
        {
          className: responsiveWidth,
          paddingRight: ["none", index < tabList.length - 1 ? "gutter" : null],
          children: /* @__PURE__ */ jsx(
            Tab,
            {
              href,
              text,
              tabId,
              isActive,
              linkContext,
              isNew
            }
          )
        },
        `tab_${index}`
      )
    )
  }
));
export {
  Tabs
};
